<header class="header">
  <h1 class="header__title" translate="verification.routing.full"></h1>
  <btn
    [link]="true"
    (action)="promptSkip()"
    buttonText="common.btn.later"
    class="header__skip"
    data-e2e-element="verify-later.button"
  ></btn>
</header>

<ng-container *ngrxLet="idStatus$ as idStatus; suspenseTpl: loading">
  <div
    *ngIf="idStatus === statuses.rejected"
    class="notification alert-warning"
    data-e2e-element="identity.status.rejected"
  >
    <span class="c-red" translate="profile-identity.status.rejected"></span>
    <div>
      <span translate="profile-identity.label.reason"></span>&nbsp;<span [innerHTML]="rejectReason$ | async"></span>
    </div>
  </div>
  <div
    *ngIf="[statuses.none, statuses.rejected, statuses.started].includes(idStatus)"
    class="b-center"
  >
    <div class="b-sm-content column-dir-center">
      <div class="b-style padding-primary identity">
        <h3 class="form-title" translate="register-identity.subtitle"></h3>
        <ul class="advantage-list">
          <li class="advantage-list__item">
            <icon width="20px" height="20px" src="assets/img/icons/i-shield-2.svg"></icon>
            <span translate="register-identity.advantage-1"></span>
          </li>
          <li class="advantage-list__item">
            <icon width="20px" height="20px" src="assets/img/icons/i-card.svg"></icon>
            <span translate="register-identity.advantage-2"></span>
          </li>
          <li class="advantage-list__item">
            <icon width="20px" height="20px" src="assets/img/icons/i-withdraw.svg"></icon>
            <span translate="register-identity.advantage-3"></span>
          </li>
        </ul>
        <pac-alert
          type="info"
          title="profile-identity.info.duration"
          class="duration-info"
        ></pac-alert>
        <form (ngSubmit)="onSubmit()" [formGroup]="verificationForm"
              [class.error]="!verificationForm.valid && verificationForm.touched">
          <div class="form-group">
            <ng-container *ngIf="{ focus: false, control: verificationForm.get('name'), field: 'name' } as ctx">
              <app-form-field
                [isControlTouched]="ctx.control.touched"
                [errors]="ctx.control.errors"
                [errorTexts]="fieldErrors[ctx.field]"
                [submitErrors]="submitErrors.asObservable()"
              >
                <label
                  [for]="ctx.field"
                  [class.fade-in]="ctx.control.value || ctx.focus"
                  translate="profile-identity.field.name-2"
                ></label>
                <input
                  (focus)="ctx.focus = true"
                  (blur)="ctx.focus = false"
                  [placeholder]="('profile-identity.field.name-2') | translate"
                  [id]="ctx.field"
                  type="text"
                  class="form-control"
                  autocomplete="name"
                  maxlength="64"
                  formControlName="name"
                  name="name"
                  data-e2e-element="identity.input.name"
                />
                <p
                  class="ident-text name-hint"
                  translate="profile-identity.description.name-2"
                ></p>
              </app-form-field>
            </ng-container>

            <ng-container *ngIf="{ focus: false, control: verificationForm.get('passport'), field: 'passport' } as ctx">
              <app-form-field
                [isControlTouched]="ctx.control.touched"
                [errors]="ctx.control.errors"
                [errorTexts]="fieldErrors[ctx.field]"
                [submitErrors]="submitErrors.asObservable()"
              >
                <label
                  [for]="ctx.field"
                  [class.fade-in]="ctx.control.value || ctx.focus"
                  translate="profile-identity.field.passport-2"
                ></label>
                <input
                  (focus)="ctx.focus = true"
                  (blur)="passportControlBlur(ctx)"
                  [id]="ctx.field"
                  [placeholder]="('profile-identity.field.passport-2') | translate"
                  type="text"
                  class="form-control"
                  autocomplete="passport"
                  maxlength="64"
                  formControlName="passport"
                  name="passport"
                  data-e2e-element="identity.input.passport"
                />
              </app-form-field>
            </ng-container>

            <ng-container
              *ngIf="{ focus: false, control: verificationForm.get('birthDate'), field: 'birthDate' } as ctx">
              <app-form-field [isControlTouched]="ctx.control.touched"
                              [errors]="ctx.control.errors"
                              [errorTexts]="fieldErrors[ctx.field]"
                              [submitErrors]="submitErrors.asObservable()">
                <calendar-input [id]="'birthDate'"
                                [readonly]="false"
                                [ctrl]="ctx.control"
                                [label]="'profile-identity.field.birth-date' | translate"
                                [max]="maxDate"
                                [min]="minDate"
                                (dateChange)="trackDateInputEvent()"
                                data-e2e-element="identity.input.birthdate"></calendar-input>
              </app-form-field>
            </ng-container>

            <ng-container *ngIf="{ focus: false, control: verificationForm.get('files'), field: 'files' } as ctx">
              <app-form-field [isControlTouched]="ctx.control.touched"
                              [errors]="ctx.control.errors"
                              [errorTexts]="fieldErrors[ctx.field]"
                              [submitErrors]="submitErrors.asObservable()">
                <div
                  translate="profile-identity.field.upload-2"
                  class="ident-h3"
                ></div>

                <p class="ident-text photo-description"
                   [innerHTML]="('profile-identity.description.upload-2') | translate"
                ></p>
                <div class="passport-examples">
                  <figure>
                    <img src="./assets/img/verification/identity/correct-passport.jpg" alt="Correct passport">
                    <figcaption>{{ 'profile-identity.figure.passport.correct' | translate }}</figcaption>
                  </figure>
                  <figure>
                    <img src="./assets/img/verification/identity/cropped-passport.jpg" alt="Cropped passport">
                    <figcaption>{{ 'profile-identity.figure.passport.cut' | translate }}</figcaption>
                  </figure>
                  <figure>
                    <img src="./assets/img/verification/identity/glared-passport.jpg" alt="Glared passport">
                    <figcaption>{{ 'profile-identity.figure.passport.glared' | translate }}</figcaption>
                  </figure>
                  <figure>
                    <img src="./assets/img/verification/identity/blurred-passport.jpg" alt="Blurred passport">
                    <figcaption>{{ 'profile-identity.figure.passport.blurred' | translate }}</figcaption>
                  </figure>
                </div>
                <div
                  translate="profile-identity.label.identification-2"
                  class="ident-h3"
                ></div>

                <global-file-attach
                  [ctrl]="ctx.control"
                  [settings]="fileAttachSettings"
                  (downloadLabelClicked)="trackUploadDocumentTapped()"
                  (addingFileStart)="trackAddingFileStart()"
                  (addingFileEnd)="trackAddingFileEnd()"
                  data-e2e-element="identity.input.files"
                ></global-file-attach>
              </app-form-field>

              <p class="requirement" [innerHTML]="'verification.file-requirements' | translate: { formats: imageFileTypes, size: 10 }"></p>
              <p class="requirement" [innerHTML]="'verification.file-requirements' | translate: { formats: documentFileTypes, size: 0.5 }"></p>
            </ng-container>
            <div class="actions-wrapper actions-wrapper--column">
              <button class="button" data-e2e-element="identity.button.submit" type="submit" [disabled]="isLoading">
                <i class="fas fa-cog fa-spin" [hidden]="!isLoading"></i>
                <span translate="profile-identity.label.send-request-2"></span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <a
        class="link link--standalone"
        routerLink="/finances/deposit"
        [queryParams]="{list: true}"
        translate="profile-identity.link.deposit"
      ></a>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <app-loader [isOverlay]="true"></app-loader>
</ng-template>
